export enum MotorsPackageTypeEnum {
    PREMIUM = 3,
    STANDARD = 2,
    BASIC = 1,
    UNASSIGNED = 0
}